// extracted by mini-css-extract-plugin
module.exports = {"table":"TableExperience_table__1MYD8","message":"TableExperience_message__2jk7x"};